import React from 'react'
import { INLINE_STYLES } from './InlineStyles';
import StyleButton from '../StyleButton';
import { getSelectionInlineStyle } from 'draftjs-utils';

function InlineStyleControls ({editorState, onToggle }) {

    const currentStyle = getSelectionInlineStyle(editorState);
        
    return (
        <>
            {INLINE_STYLES.map((control, i) => {
                return (
                    <StyleButton
                        key={i}
                        onToggle={onToggle}
                        active={currentStyle[control.value]}
                        control={control}
                    />
                )
            })}
            
        </>
    )
}

export default InlineStyleControls;
